export default "__VITE_ASSET__CT865Ter__"